/**
 * A CSV file that a spreadsheet opens: one line per row, cells joined with commas, lines with CRLF.
 * A cell with a quote, a comma or a line break goes in quotes, and its quotes are doubled.
 * A text cell that a spreadsheet can run as a formula gets a ' first, so it shows as text: a cell that
 * starts with =, @, a tab or a carriage return, or with + or - and then more than a number (a phone
 * number such as +971 50 123 4567 stays as it is), also after spaces or control characters. Numbers stay as they are.
 */
export function csvCell(value: string | number): string {
  const text = typeof value === "string" && isFormula(value) ? `'${value}` : String(value);
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

function isFormula(text: string): boolean {
  // Spaces and control characters before the marker do not stop a spreadsheet (review T2 R2.1).
  const start = text.replace(/^[\s\u0000-\u001f]+/, "");
  if (start !== text && /^[=@+-]/.test(start)) return true;
  if (/^[=@\t\r]/.test(text)) return true;
  return /^[+-]/.test(text) && !/^[+-][\d .()]*$/.test(text);
}

/** The header row and the rows, as the text of one CSV file. */
export function csvText(header: ReadonlyArray<string>, rows: ReadonlyArray<ReadonlyArray<string | number>>): string {
  return [header, ...rows].map((row) => row.map(csvCell).join(",")).join("\r\n");
}
